<mat-form-field
  class="px-3"
  [formGroup]="tempFormGroup"
  [floatLabel]="currentConfig?.tooltipConfig?.tooltipDesc ? 'always' : 'auto'"
>
  <ng-template
    raMatLabelTooltip
    [tooltipConfig]="currentConfig?.tooltipConfig"
  ></ng-template>
  <mat-label>{{ currentConfig.displayText }}</mat-label>
  <mat-select
    #matSelect
    id="boolean-dropdown"
    [disableOptionCentering]="true"
    [formControlName]="'value'"
    (opened)="getDropdownValues(currentConfig)"
    (selectionChange)="onValueChanged()"
    [ngClass]="{
      'read-only':
        readOnly || currentConfig?.orderOnly || currentConfig?.readOnly,
    }"
  >
    @if (!currentConfig.values) {
      <mat-option>Loading...</mat-option>
    }
    @for (value of currentConfig.values; track value) {
      <mat-option
        [value]="
          currentConfig.dropdownID ? value[currentConfig.dropdownID] : value
        "
      >
        {{
          currentConfig.dropdownLabel
            ? value[currentConfig.dropdownLabel]
            : value
        }}
      </mat-option>
    }
  </mat-select>
  <mat-error>
    {{
      currentConfig?.errorMessages?.[
        keys(parentFormGroup?.get(currentConfig.property)?.errors)?.[0]
      ] || "Please review the field"
    }}
  </mat-error>
</mat-form-field>
